import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/', component: () => import('../pages/index'),
      meta: { 'title': '首页' }
    },
    {
      path: '/login', component: () => import('../pages/login'),
      meta: { 'title': '智慧羊场管理平台' }
    },
    {
      path: '/register', component: () => import('../pages/register'),
      meta: { 'title': '注册新账号' }
    },
    {
      path: '/forgotPassword', component: () => import('../pages/forgotPassword'),
      meta: { 'title': '忘记密码' }
    },
    {
      path: '/improveData', component: () => import('../pages/improveData'),
      meta: { 'title': '完善资料' }
    },
    {
      path: '/yzgl~breedingRam', component: () => import('../pages/breedingRam'),
      meta: { 'title': '繁育公羊' }
    },
    {
      path: '/yzgl~expansionPlan', component: () => import('../pages/expansionPlan/index'),
      meta: { 'title': '扩栏(繁)计划' }
    },
    {
      path: '/yzgl~listingPlan', component: () => import('../pages/listingPlan/index'),
      meta: { 'title': '出栏计划' }
    },
    {
      path: '/yzgl~lambingPlan', component: () => import('../pages/lambingPlan/index'),
      meta: { 'title': '产羔计划' }
    },
    {
      path: '/yzgl~breedingStandards', component: () => import('../pages/breedingStandards/index'),
      meta: { 'title': '养殖标准' }
    },
    {
      path: '/yzgl~breeTasks', component: () => import('../pages/breeTasks/index'),
      meta: { 'title': '养殖任务分类' }
    },
    {
      path: '/yzgl~breedingParameters', component: () => import('../pages/breedingParameters/index'),
      meta: { 'title': '养殖参数' }
    },
    {
      path: '/gzt~taskManagement', component: () => import('../pages/taskManagement/index'),
      meta: { 'title': '任务' }
    },
    {
      path: '/gzt~approval', component: () => import('../pages/approval/index'),
      meta: { 'title': '审批' }
    },
    {
      path: '/yzgl~breedingEwe', component: () => import('../pages/breedingEwe'),
      meta: { 'title': '繁育母羊' }
    },
    {
      path: '/yzgl~yearling', component: () => import('../pages/yearling'),
      meta: { 'title': '羔羊/待产/保育' }
    },
    {
      path: '/yzgl~fatteningRam', component: () => import('../pages/fatteningRam'),
      meta: { 'title': '育肥公羊' }
    },
    {
      path: '/yzgl~fatteningEwe', component: () => import('../pages/fatteningEwe'),
      meta: { 'title': '育肥母羊' }
    },
    {
      path: '/yzgl~lsolationSheep', component: () => import('../pages/lsolationSheep'),
      meta: { 'title': '隔离羊' }
    },
    {
      path: '/csfsz~fieldSettings', component: () => import('../pages/fieldSettings'),
      meta: { 'title': '场设置' }
    },
    {
      path: '/csfsz~zoneSettings', component: () => import('../pages/zoneSettings'),
      meta: { 'title': '区设置' }
    },
    {
      path: '/csfsz~groupSettings', component: () => import('../pages/groupSettings'),
      meta: { 'title': '群设置' }
    },
    {
      path: '/csfsz~rounding', component: () => import('../pages/rounding'),
      meta: { 'title': '舍设置' }
    },
    {
      path: '/csfsz~circleSetting', component: () => import('../pages/circleSetting'),
      meta: { 'title': '圈设置' }
    },
    {
      path: '/csfsz~classification', component: () => import('../pages/classification'),
      meta: { 'title': '产品分类' }
    },
    {
      path: '/csfsz~product', component: () => import('../pages/product'),
      meta: { 'title': '产品' }
    },
    {
      path: '/csfsz~lotDevices', component: () => import('../pages/lotDevices'),
      meta: { 'title': '物联设备' }
    },
    {
      path: '/csfsz~inputSettings', component: () => import('../pages/inputSettings'),
      meta: { 'title': '投入品设置' }
    },
    {
      path: '/csfsz~productSettings', component: () => import('../pages/productSettings'),
      meta: { 'title': '商品设置' }
    },
    {
      path: '/xtgl~organizationSettings', component: () => import('../pages/organizationSettings'),
      meta: { 'title': '组织设置' }
    },
    {
      path: '/xtgl~userSettings', component: () => import('../pages/userSettings'),
      meta: { 'title': '用户设置' }
    },
    {
      path: '/xtgl~rolePermissions', component: () => import('../pages/rolePermissions'),
      meta: { 'title': '角色权限' }
    },
    {
      path: '/xtgl~dataDictionary', component: () => import('../pages/dataDictionary'),
      meta: { 'title': '数据字典' }
    },
    {
      path: '/xtgl~approvaSettings', component: () => import('../pages/approvaSettings'),
      meta: { 'title': '审批设置' }
    },
    {
      path: '/statisticalReport', component: () => import('../pages/statisticalReport'),
      meta: { 'title': '统计报表' }
    },
    {
      path: '/gylPage', component: () => import('../pages/gylPage'),
      meta: { 'title': '供应链' }
    },
    {
      path: '/basicSettings', component: () => import('../pages/basicSettings'),
      meta: { 'title': '基础设置' }
    },
    {
      path: '/breedingExperts', component: () => import('../pages/breedingExperts'),
      meta: { 'title': '养殖专家' }
    }
    ,
    {
      path: '/subjectSelection', component: () => import('../pages/subjectSelection'),
      meta: { 'title': '选择机构' }
    },
    {
      path: '/jxc/cg/purchaseOrder/index', component: () => import('../pages/purchaseOrder/index'),
      meta: { 'title': '采购订单' }
    },
    {
      path: '/jxc/cg/purchaseReceipt/index', component: () => import('../pages/purchaseReceipt/index'),
      meta: { 'title': '采购入库' }
    },
    {
      path: '/jxc/cg/purchaseReturn/index', component: () => import('../pages/purchaseReturn/index'),
      meta: { 'title': '采购退货' }
    },
    {
      path: '/jxc/cg/paymentVerification/index', component: () => import('../pages/paymentVerification/index'),
      meta: { 'title': '应付款核销' }
    },
    {
      path: '/jxc/xs/saleOrder/index', component: () => import('../pages/saleOrder/index'),
      meta: { 'title': '销售订单' }
    },
    {
      path: '/jxc/xs/salesOutbound/index', component: () => import('../pages/salesOutbound/index'),
      meta: { 'title': '销售出库' }
    },
    {
      path: '/jxc/xs/salesReturns/index', component: () => import('../pages/salesReturns/index'),
      meta: { 'title': '销售退货' }
    },
    {
      path: '/jxc/xs/collectionVerification/index', component: () => import('../pages/collectionVerification/index'),
      meta: { 'title': '应收款核销' }
    },
    {
      path: '/jxc/kc/warehouseManagement/index', component: () => import('../pages/warehouseManagement/index'),
      meta: { 'title': '入库管理' }
    },
    {
      path: '/jxc/kc/outboundManagement/index', component: () => import('../pages/outboundManagement/index'),
      meta: { 'title': '出库管理' }
    },
    {
      path: '/jxc/kc/transferOutbound/index', component: () => import('../pages/transferOutbound/index'),
      meta: { 'title': '调拨出库' }
    },
    {
      path: '/jxc/kc/inventoryQuery/index', component: () => import('../pages/inventoryQuery/index'),
      meta: { 'title': '库存查询' }
    },
    {
      path: '/jxc/kc/inventoryAnalysis/index', component: () => import('../pages/inventoryAnalysis/index'),
      meta: { 'title': '库存分析' }
    },
    {
      path: '/jxc/kc/inventorySurplus/index', component: () => import('../pages/inventorySurplus/index'),
      meta: { 'title': '库存盘盈' }
    },
    {
      path: '/jxc/kc/inventoryLoss/index', component: () => import('../pages/inventoryLoss/index'),
      meta: { 'title': '库存盘亏' }
    },
    {
      path: '/jxc/bb/procurementStatistics/index', component: () => import('../pages/procurementStatistics/index'),
      meta: { 'title': '采购统计' }
    },
    {
      path: '/jxc/bb/salesStatistics/index', component: () => import('../pages/salesStatistics/index'),
      meta: { 'title': '销售统计' }
    },
    {
      path: '/jxc/bb/inventoryDetails/index', component: () => import('../pages/inventoryDetails/index'),
      meta: { 'title': '入库明细' }
    },
    {
      path: '/jxc/bb/outboundDetails/index', component: () => import('../pages/outboundDetails/index'),
      meta: { 'title': '出库明细' }
    },
    {
      path: '/jxc/bb/transferDetails/index', component: () => import('../pages/transferDetails/index'),
      meta: { 'title': '调拨明细' }
    },
    {
      path: '/jxc/bb/receiptSummary/index', component: () => import('../pages/receiptSummary/index'),
      meta: { 'title': '入库汇总' }
    },
    {
      path: '/jxc/bb/outboundSummary/index', component: () => import('../pages/outboundSummary/index'),
      meta: { 'title': '出库汇总' }
    },
    {
      path: '/jxc/pz/category/index', component: () => import('../pages/category/index'),
      meta: { 'title': '商品分类' }
    },
    {
      path: '/jxc/pz/commodityInformation/index', component: () => import('../pages/commodityInformation/index'),
      meta: { 'title': '商品信息' }
    },
    {
      path: '/jxc/pz/supplierInformation/index', component: () => import('../pages/supplierInformation/index'),
      meta: { 'title': '供应商信息' }
    },
    {
      path: '/jxc/pz/customer/index', component: () => import('../pages/customer/index'),
      meta: { 'title': '客户信息' }
    },
    {
      path: '/jxc/pz/warehouseInformation/index', component: () => import('../pages/warehouseInformation/index'),
      meta: { 'title': '仓库信息' }
    },
    {
      path: '/wlsb~scada', component: () => import('../pages/scada/index'),
      meta: { 'title': '实时监控' }
    }
    ,
    {
      path: '/wlsb~query', component: () => import('../pages/query/index'),
      meta: { 'title': '数据查询' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js